var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "navigation-view-selector" },
    _vm._l(_vm.getOptions, function(item, index) {
      return _c(
        "div",
        {
          key: "navigationTypeView" + index,
          staticClass: "navigation-view-selector__option",
          class: [{ active: _vm.evalViewType(item.id) }],
          on: {
            click: function($event) {
              return _vm.$emit("on-select-view", item.id)
            }
          }
        },
        [_c("span", [_vm._v(_vm._s(item.name))])]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }